module.exports = __webpack_public_path__ + "img/202009.4342536d.png";